module.exports = __webpack_public_path__ + "static/media/D_8.866fe338.png";